export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-press-release/_ct-press-release.twig";